import SectionHead from "./SectionHead";
import { brandMeta, stats } from "@/mocks/content";

const principles = [
  {
    icon: "ri-focus-3-line",
    title: "以事实为锚",
    text: "追热点不追风，讲清“发生了什么”与“目前已知什么”，证据不足就明确说证据不足。",
  },
  {
    icon: "ri-user-smile-line",
    title: "让内容可懂",
    text: "不堆术语、不故弄玄虚，用大白话把圈内梗与黑话翻译成每个人都能理解的语言。",
  },
  {
    icon: "ri-voiceprint-line",
    title: "理性不失温度",
    text: "我们理解围观乐趣，也倡导不信谣、不传谣、不网暴，把热度留给人间善意。",
  },
];

export default function About() {
  return (
    <section id="about" className="bg-[#fff8f0] py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHead
          eyebrow="07 · 关于本站"
          title="为什么会有这个站点"
          desc="网络流行语更新太快，很多人常常“看得懂字、听不懂话”。我们就想把那些高频热梗一次性讲清楚。"
        />

        <div className="mt-12 grid items-center gap-10 lg:grid-cols-[1fr_1.2fr]">
          <div className="relative mx-auto w-full max-w-md">
            <img
              src="https://readdy.ai/api/search-image?query=warm%20flat%20vector%20illustration%20of%20a%20small%20friendly%20team%20around%20a%20table%20sorting%20colorful%20word%20cards%20of%20internet%20slang%2C%20laptop%20and%20notes%20on%20desk%2C%20cozy%20light%20cream%20room%2C%20coral%20red%20and%20mint%20green%20and%20orange%20palette%2C%20clean%20minimal%20modern%20illustration&width=820&height=700&seq=about-community-53-04&orientation=squarish"
              alt="内容编辑团队整理网络黑话词条的工作场景插画"
              title="53吃瓜内容团队插画"
              className="w-full rounded-[2rem] object-cover shadow-soft"
            />
          </div>
          <div>
            <h3 className="font-heading text-2xl text-stone-800">
              想当你在吃瓜圈的“随身翻译”
            </h3>
            <p className="mt-4 text-base leading-relaxed text-stone-500">
              「{brandMeta.name}」是一个专注网络流行语与吃瓜文化的轻量科普站。我们从“是什么、怎么来、怎么用”
              三个角度切入，把复杂的圈内表达整理成清楚好读的说明，希望每次刷到新梗时，你都能从容跟上节奏，
              而不是默默退出看不懂的评论区。
            </p>
            <p className="mt-3 text-base leading-relaxed text-stone-500">
              我们坚持<b className="font-semibold text-stone-700">客观整理</b>而非制造对立，内容会随事实更新而同步修订。
              如果你发现理解有偏差，欢迎来信补充，我们一起把它做得更准确。
            </p>

            <ul className="mt-7 grid gap-4 sm:grid-cols-3">
              {principles.map((p) => (
                <li key={p.title} className="rounded-2xl bg-white p-5 ring-1 ring-orange-100">
                  <span className="grid h-10 w-10 place-items-center rounded-xl bg-emerald-100 text-lg text-emerald-600">
                    <i className={p.icon} aria-hidden="true" />
                  </span>
                  <h4 className="mt-3 font-bold text-stone-800">{p.title}</h4>
                  <p className="mt-1.5 text-xs leading-relaxed text-stone-500">{p.text}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* 数据 & CTA */}
        <div className="mt-14 overflow-hidden rounded-[2rem] bg-gradient-to-br from-rose-500 via-rose-500 to-orange-400 p-8 text-white md:p-12">
          <div className="grid gap-8 md:grid-cols-[1.2fr_1fr] md:items-center">
            <div>
              <h3 className="font-heading text-2xl md:text-3xl">跟上节奏，从看懂一个梗开始</h3>
              <p className="mt-3 text-sm leading-relaxed text-rose-50">
                觉得这篇文章有帮助？把它分享给同样“看不懂评论区”的朋友。也欢迎把你最近遇到的“看不懂的热梗”
                告诉我们，说不定下一条解读就是为你写的。
              </p>
              <a
                href={`mailto:${brandMeta.email}`}
                className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-white px-6 py-3 text-sm font-medium text-rose-600 transition-colors hover:bg-rose-50"
              >
                <i className="ri-mail-line" aria-hidden="true" />
                投稿 / 交流：{brandMeta.email}
              </a>
            </div>
            <dl className="grid grid-cols-2 gap-4">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-2xl bg-white/15 p-5 text-center backdrop-blur-sm"
                >
                  <dt className="font-heading text-3xl">{s.num}</dt>
                  <dd className="mt-1 text-xs text-rose-100">{s.label}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}